import type { UseFormRegisterReturn } from 'react-hook-form'
import { CheckboxBox } from './checkbox-box'

export const CheckboxGroup = ({
  id,
  register,
  options
}: {
  id: string
  register: UseFormRegisterReturn
  options: { label: string; value: string }[]
}) => {
  return (
    // 選択肢の縦間隔は Figma の checkboxes（お問い合わせ）の itemSpacing 12
    <div className="flex flex-col gap-3">
      {options.map((option, index) => {
        const inputId = `${id}_${index}`
        return (
          <label
            key={option.value}
            htmlFor={inputId}
            className="flex cursor-pointer items-start gap-3 text-left"
          >
            <CheckboxBox>
              <input
                type="checkbox"
                id={inputId}
                value={option.value}
                className="peer sr-only"
                {...register}
              />
            </CheckboxBox>
            <span className="text-sm leading-compact text-ink">
              {option.label}
            </span>
          </label>
        )
      })}
    </div>
  )
}
